import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useEmployerJobApi } from "src/_common/hooks/actions/job/appEmployerJobApiHook";
import { useJobListSelector } from "src/_common/hooks/selectors/jobSelector.";
import JobListingsSection from "./JobListingsSection";
import { useTranslation } from "src/_common/hooks/useTranslation";
import UpcomingInterviewSection from "./UpcomingInterviewSection";
import ApplicationChart from "./ApplicationChart";

export default function DashboardMain() {
  const { t } = useTranslation("dashboard");
  const history = useHistory();
  const jobListings = useJobListSelector();
  const { callGetJobStatusCounts } = useEmployerJobApi();
  const [jobStatusCounts, setJobStatusCounts] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  // Load job status counts on component mount
  useEffect(() => {
    loadJobStatusCounts();
  }, []);

  const loadJobStatusCounts = (jobIds: string[] = []) => {
    setLoading(true);
    callGetJobStatusCounts(
      jobIds,
      (message: string, data: any) => {
        setJobStatusCounts(data);
        setLoading(false);
      },
      (error: string) => {
        console.error("Failed to load job status counts:", error);
        setLoading(false);
      }
    );
  };

  return (
    <div className="dashboard-main">
      <div className="dashboard-header">
        <h1 className="dashboard-title">{t("dashboard.title")}</h1>
        <p className="dashboard-subtitle">{t("dashboard.subtitle")}</p>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card active-listings">
          <div className="stat-header">
            <p className="stat-title">{t("dashboard.stats.activeListings.title")}</p>
            <div className="stat-icon active">★</div>
          </div>
          <div className="stat-number">
            {jobListings?.filter((job: any) => job.status === 1 || job.status === 10)?.length || 0}
          </div>
          <div className="stat-change">
            {jobStatusCounts?.current_week_applied_job_count} {t("dashboard.stats.activeListings.newThisWeek")}
          </div>
        </div>

        <div className="stat-card total-applications">
          <div className="stat-header">
            <p className="stat-title">{t("dashboard.stats.totalApplications.title")}</p>
            <div className="stat-icon applications"></div>
          </div>
          <div className="stat-number">{jobStatusCounts?.screened}</div>
          <div className="stat-change">
            {jobStatusCounts?.today_screened} {t("dashboard.stats.totalApplications.newToday")}
          </div>
        </div>

        <div
          className="stat-card interviews-scheduled"
          onClick={() => history.push("/interview-schedule")}
          style={{ cursor: "pointer" }}
        >
          <div className="stat-header">
            <p className="stat-title">{t("dashboard.stats.interviewsScheduled.title")}</p>
            <div className="stat-icon interviews"></div>
          </div>
          <div className="stat-number">{jobStatusCounts?.total_interview_schedule}</div>
          <div className="stat-change">
            {jobStatusCounts?.today_interview_schedule} {t("dashboard.stats.interviewsScheduled.scheduledToday")}
          </div>
        </div>

        <div className="stat-card hired-month">
          <div className="stat-header">
            <p className="stat-title">{t("dashboard.stats.hiredThisMonth.title")}</p>
            <div className="stat-icon hired"></div>
          </div>
          <div className="stat-number">{jobStatusCounts?.hired_this_month}</div>
          <div className="stat-change">
            {jobStatusCounts?.hired_today} {t("dashboard.stats.hiredThisMonth.target")}
          </div>
        </div>
      </div>

      {/* Application Statistics Chart */}
      <div className="chart-section">
        {/* Upcoming Interview Section */}
        <UpcomingInterviewSection />
        <div className="chart-container">
          <div className="section-header">
            <h2 className="section-title">{t("dashboard.chart.title")}</h2>
          </div>
          <ApplicationChart />
        </div>
      </div>
      {/* Job Listings Section */}
      <JobListingsSection />
    </div>
  );
}
